<kbxl-user-communication-display
  [userCommunications]="userCommunications$ | async"
  [processing]="processing$ | async"
  [isMobile]="isMobile$ | async"
>
</kbxl-user-communication-display>
